import React, { FunctionComponent } from 'react';

import { css } from '@emotion/react';

import { palette } from '@styles/theme';

interface Props {
  height?: number;
  children?: any;
}

const FormRow: FunctionComponent<Props> = ({ height, children }) => {
  const width = 100 / (children?.length ?? 1);

  return (
    <li>
      <ul css={container(width, height)}>{children}</ul>
    </li>
  );
};

export default FormRow;

const container = (width: number, height?: number) => css`
  height: ${height ? `${height}px` : 'auto'};
  // overflow: hidden;
  padding: 0;
  list-style: none;
  border-bottom: 1px solid ${palette.gray3};
  width: 100%;
  & > li {
    width: ${width}%;
  }

  display: flex;
`;
